import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useUser } from '../../../context/UserContext';
import { useReportContext } from '../../../context/DetailContext';

interface Props {
  title: string;
  children: React.ReactNode;
  isCenter?: boolean;
}

const LimitFilter = ({ title, children, isCenter = true }: Props) => {
  const { user } = useUser();
  const { quotaAccess } = useReportContext();

  const convertRegion = (planRegion: string) => {
    if (!planRegion) return '';
    const regionCode = planRegion.split(',');

    const regionMap: Record<string, string> = {
      A: '전국',
      B: '수도권(서울,경기,인천)',
      C: '서울',
      D: '경기',
      E: '인천',
      F: '지방 통합(수도권 제외 전지역)',
      G: '충청권',
      H: '강원권',
      I: '경상권',
      J: '호남권',
      K: '제주도',
    };

    const regions = regionCode.map((code: string) => regionMap[code]);

    return regions.join(', ');
  };

  const isRegion = user?.plan_grade && quotaAccess;
  const regionName = convertRegion(user?.plan_region ?? '');

  return (
    <Wrapper>
      <UserFilterOverlay $isCenter={isCenter}>
        <img
          src="/assets/images/icon/table_lock.svg"
          alt="lock"
          width={32}
          height={32}
        />
        <TextWrapper>
          <MainText>
            {isRegion
              ? '이용 중인 상품으로 열람할 수 없는 내용입니다.'
              : `${title} \n유료 회원만 열람 가능해요.`}
          </MainText>
          <SubText>
            {isRegion
              ? `현재 보유 요금제:  ${regionName}`
              : '요금제를 구매하고 땅집고옥션 서비스를 이용해보세요!'}
          </SubText>
        </TextWrapper>
        <Button onClick={() => (window.location.href = '/payment/plan')}>
          {isRegion ? '요금제 업그레이드' : '요금제 보러가기'}
        </Button>
        {/* </BottomCover> */}
      </UserFilterOverlay>
      {children}
    </Wrapper>
  );
};

export default LimitFilter;

const Wrapper = styled.div`
  position: relative;
  min-height: 258px;
`;

const UserFilterOverlay = styled.div<{ $isCenter: boolean }>`
  position: absolute;
  top: 0;
  left: 0;
  z-index: 5;
  width: 100%;
  height: 100%;
  pointer-events: auto;
  display: flex;
  flex-direction: column;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: ${({ $isCenter }) => ($isCenter ? 'center' : 'flex-start')};
  gap: 24px;
  backdrop-filter: blur(3px);
  background: linear-gradient(
    to bottom,
    #ffffffcc 0%,
    #ffffffcc 30%,
    #ffffff 100%
  );

  ${({ $isCenter }) =>
    !$isCenter &&
    `
      padding: 40px 0;
  `}
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: center;
`;

const MainText = styled.div`
  font-weight: 700;
  font-size: 16px;
  color: #222;
  white-space: pre-line;
  text-align: center;
`;

const SubText = styled.div`
  font-weight: 500;
  font-size: 14px;
  color: #616161;
  text-align: center;
`;

const Button = styled.button`
  padding: 12px 28px;
  border-radius: 8px;
  background-color: #008aff;
  color: white;
  font-weight: 500;
  font-size: 16px;
  cursor: pointer;
  border: none;
`;
